import { ethers } from 'ethers';
import abi from './abi/Jobready.json';

// Create a provider using the desired Ethereum RPC URL
const provider = new ethers.providers.JsonRpcProvider('https://eth-rpc-api-testnet.thetatoken.org/rpc');

// If the user is connected to MetaMask or a similar provider, you can use the following line instead:
// const provider = new ethers.providers.Web3Provider(window.ethereum);

declare global {
  interface Window {
    ethereum?: any;
  }
}

let signer;

// Check if the user is using MetaMask or a similar provider
if (window.ethereum) {
  signer = provider.getSigner();
} else {
  signer = provider; // Use the provider directly for non-browser environments
}

const jobReadyInterface = new ethers.utils.Interface(abi);
export const jobreadyAddress = '0xCfC2727BC7ecfb6B2fC54B5aC764C7338d277D10';

export const JobreadyContract = new ethers.Contract(jobreadyAddress, jobReadyInterface, signer);
